let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lS8jn")).then(() => parcelRequire('ipVew'));